import { api2 , apiUpload } from './ApiService';

export default class UidImageService {
    
    static async get(type){
        let response =  await api2.get(`api/v1/uid/image/all`)
        return response.data
    }

    static async search(key,page,perpage){
        let data ={
            searchKey: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/uid/image/search`,data)
        return response.data
    }
    
    static async create(formData){
        let response = await apiUpload.post(`/api/v1/uid/image/create`,formData)
        return response.data
    }
     static async delete(data){
        let response = await api2.post(`/api/v1/uid/image/delete`,data)
        return response.data
    }
}


// WEBPACK FOOTER //
// ./src/service/UidImageService.js